import { BaseEntity } from 'src/app/tools/models/baseEntity';
import { SdeliveryNote } from './s-delivery-note';
import { WarehouseTransferRequest } from './warehouse-transfer-request';
import { WarehouseTransferLine } from './warehouse-transfer-line';
import { Role } from 'src/app/assabil-kernel/models/entities/master-data/role-entity';
import { Porder } from './porder';


export class WarehouseTransfer extends BaseEntity {
  
  warehouseTransferCode     : string;
  progressLevel             : number;

  sdeliveryNotes 				    : SdeliveryNote[];
  warehouseTransferRequests : WarehouseTransferRequest[] = [];
  warehouseTransferLines    : WarehouseTransferLine[] = [];

  porder                    : Porder;
  
  confirmedByRole           : Role;
  requestedForRole          : Role;
  assignedByRole            : Role;
  theDate                   : Date;
  transferType              : number;
  canceled                  : boolean;

  returnWt                  : boolean = false;
  userField1                : string;
  userField2                : string;
  confirmationDate          : Date ;
  assignmentDate            : Date;
  
  constructor() {
    super()
  }
 
}
 

